import React, { useCallback } from 'react';

import KnobInput from 'components/form/KnobInput.component';
import WidgetTitle from 'components/widget/WidgetTitle.component';
import TIME_OFF_DURATIONS from 'constants/timeoff/durations.const';
import useStateWhileMounted from 'hooks/useStateWhileMounted.hook';
import { useTranslation } from 'providers/GILT.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import call from 'utils/functions/call.util';
import asObject from 'utils/objects/asObject.util';
import isMissing from 'utils/predicates/any/isMissing.util';

import CN from './WidgetDuration.module.scss';

const WidgetDuration = ({
  selected: selectedFromProps,
  name: nameFromProps,
  tag: tagFromProps,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();
  const name = fromAnyToTrimmed(nameFromProps);
  const tag = fromAnyToTrimmed(tagFromProps);

  const [selected, setSelected] = useStateWhileMounted(selectedFromProps);
  const selectedId = asObject(selected).id;

  const handleClick = useCallback(
    (ev) => {
      const isSelected = selectedId === ev.name;
      // const id = isSelected ? null : ev.name;
      const raw = isSelected ? null : ev.raw;

      const { value } = asObject(call(`WidgetDuration.onChange`, onChange, { name, tag, raw }));

      setSelected(isMissing(value) ? raw : value);
    },
    [name, onChange, selectedId, setSelected, tag],
  );

  return (
    <div data-bem="WidgetDuration" data-tag={tag} className={CN.component}>
      <div className={CN.titleContainer}>
        <WidgetTitle tag="WidgetDuration__title">{t('scheduler.timeOff.durationTitle')}</WidgetTitle>
      </div>
      <div data-bem="WidgetDuration__list" data-tag={tag} className={CN.list}>
        {Object.values(TIME_OFF_DURATIONS)
          .filter((item) => !item.hide)
          .map((option) => (
            <KnobInput
              key={option.id}
              name={option.id}
              tag={option.id}
              value={option}
              disabled={disabled}
              selected={selectedId === option.id}
              onClick={handleClick}
            >
              {option.description}
            </KnobInput>
          ))}
      </div>
    </div>
  );
};
export default WidgetDuration;
